import { CASA_API_ERROR_MESSAGE } from "@/constant";

/**
 * 创建一个 Casa API 错误对象
 * @param originalError 原始错误对象
 * @param message 可选的自定义错误消息
 * @returns 格式化的错误对象
 */
export function createCasaApiError(
  originalError: unknown,
  message?: string
): Error {
  const err = new Error(message || CASA_API_ERROR_MESSAGE);
  (err as any).cause = originalError;
  return err;
}

/**
 * 抛出一个可以被 EnhancedErrorBoundary 捕获的 Casa API 错误
 * 使用 Promise.reject() 来触发 unhandledrejection 事件
 * @param originalError 原始错误对象
 * @param message 可选的自定义错误消息
 */
export function throwCasaApiError(
  originalError: unknown,
  message?: string
): void {
  const err = createCasaApiError(originalError, message);
  // 使用 Promise.reject() 创建未处理的 Promise 拒绝
  // 这样可以被 EnhancedErrorBoundary 的 unhandledrejection 监听器捕获
  Promise.reject(err);
}
